/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateWhatsAppIndexPathParams, CandidateWhatsAppIndexResponse } from '../types/CandidateWhatsAppIndex'

/**
 * GET /candidates/:candidateId/whatsapp
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::index
 */
export async function candidateWhatsAppIndex(
	candidateId: CandidateWhatsAppIndexPathParams['candidateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateWhatsAppIndexResponse>> {
	return axiosInstance.get(`/candidates/${candidateId}/whatsapp`, config)
}
